import { render, staticRenderFns } from "./edit-decoration-policy-form.vue?vue&type=template&id=f948dc90&scoped=true&"
import script from "./edit-decoration-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-decoration-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f948dc90",
  null
  
)

export default component.exports